module.exports = ".quick-link {\n  overflow: auto; }\n"